module.exports = __webpack_public_path__ + "img/popup9.c1ceb4cf.png";